<template>
    <div>
        <top-navbar></top-navbar>
<div>
 

<div class="container-fluid">
  <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" to="/"> Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product GIN </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/gin/index"> Manage GIN </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" :to='"/gin/view?id="+detail.SD_idstockissue'> {{ detail.SI_issueNum }} </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Update GIN Qty  </h6>
  <h6 class="custom-maintitle mb-2"><b>Update GIN Qty</b></h6>
<div class="card ">
<div class="card-body">
  <form @submit.prevent="SaveCrm()" >







    <div class="row">
        <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">Product Code</label>
            <input  v-model="detail.P_code" style="font-size: small;" class="form-control" required disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">	
Product Description</label>
            <input  v-model="detail.P_description" style="font-size: small;" class="form-control" required disabled>
    
    </div>
  </div>
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label " style="font-size: small;">	
                Qty</label>
            <input  type="number" v-model="detail.SD_qty" step="0.01" style="font-size: small;" class="form-control" required>
    </div>
  </div>
 
  
  

</div>








  
   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <button :disabled="isButtonDisabled" type="submit" class="mr-1 btn custom-btn btn-primary  mb-5 font-size_def bdr-rad">Update</button>
    </div>
    </div>



</form>
</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        'idgindetail':this.$route.query.id,

        detail:{},
       
        isButtonDisabled: false
      
      


        
      }

    },
    mounted(){
 
      this.loadContact(this.idgindetail)

      
    },
   
methods : {

 

  async loadContact(id) {
    
    try {
      const { data} = await  axios.get('/istockissue/loadupdatedetail?id='+id,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.detail = data.detail;
     
       
      
    } catch (error) {
      console.log(error.response);
    }
  },


  async SaveCrm() {
  
    this.isButtonDisabled = true;
    
    try {
      const { data} = await  axios.post('/istockissue/updatedetail?id='+this.idgindetail,{userid:this.userid,detail:this.detail},{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
      this.status = data.status;
       if(this.status == 200){
        this.isButtonDisabled = false;
        this.$router.push('/gin/update?id='+this.detail.SD_idstockissue);
       }
      
    } catch (error) {
      console.log(error.response);
    }
  },

      
    



  
 

  


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style scoped>

</style>